import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { schedularTherapistFilterAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* deleteSplitTaskMin(action: any): SagaReturnType<any> {
  try {

    yield put({type:schedularTherapistFilterAction.DELETE_SPLIT_TASK_LOADING})
    const response = yield call(
      therapistSchedulingServices.deleteSplitTaskMin,
      action.payload
    );
    if (response?.status === 200) {
      yield put({
        type: schedularTherapistFilterAction.DELETE_SPLIT_TASK_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: schedularTherapistFilterAction.DELETE_SPLIT_TASK_FAILURE,
      payload: error,
    });
  }
}

function* deleteSplitTaskMinSaga() {
  yield takeEvery(
    schedularTherapistFilterAction.DELETE_SPLIT_TASK_REQUEST,
    deleteSplitTaskMin
  );
}

export default deleteSplitTaskMinSaga;
